export default __webpack_public_path__ + "static/media/about.5a92c129.svg";